<template lang="html">
	
	<div class="list" >
		<div class="listItem" v-for="(item,index) in list" :key="index" @click="gotoDetail(item)">
			<div class="itemLeft">
				<img :src="item.cover" alt="大有空间">
			</div>
			<div class="itemRight">
				<div class="item_right_top">
					<div class="item_title">{{item.nft_name}}</div>
					<div class="item_type">
						数字文创·
						<div v-if="item.nft_type==1">图片</div>
						<div v-if="item.nft_type==2">音频</div>
						<div v-if="item.nft_type==3">视频</div>
						<div v-if="item.nft_type==4">3D</div>
					</div>
					<div class="item_time">
						{{item.time}}
					</div>
				</div>
				<div class="item_right_conent"></div>
				<div class="itemRight_bottom">
					<div class="item_title item_price">{{(item.price/100).toFixed(2)}}
						<div>X{{item.quantity}}</div>
					</div>
					<div class="item_type">创作者·{{item.nft_author}}</div>
					<div class="itemStatus" :style="{'color':item.color}">
						{{item.tag_str}}
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import {
		applyList
	} from '@/api/order'
	import {
		get_time
	} from '@/utils/utils'
	export default{
		data(){
			return{
				list:[],
				page:1,
				status:true
			}
		},
		mounted() {
			
		},
		methods:{
			apply_list() { //求购列表
			    if(!this.status) return
				applyList({
					page: this.page
				}).then(res => {
					if (res.list.length > 0){
						if(!this.list.length){
							this.$emit('notDate','')
						}
						res.list.forEach((item) => {
							item.time = get_time(item.time_format, item.time_timestamp)
							switch (item.transfer_status) {
								case 0:
									item.color = '#66B367'
									item.tag_str='求购中'
									break;
								case 1:
									item.color = '#6D80E3'
									item.tag_str='已成交'
									break;
								case 2:
									item.color = '#E56751'
									item.tag_str='已过期'
									break;
								case 3:
									item.color = '#E56751'
									break
							}
						})
						this.page += 1
						this.list = this.list.concat(res.list)
					}else{
						this.status=false
						if(!this.list.length){
							this.$emit('notDate','您暂时没有求购呦～')
						}
					}
				})
			
			},
			gotoDetail(item) { //去详情
				this.$emit('gotoDetail',item)
			},
		}
	}
	
</script>

<style>
</style>
